<div class="titleShow">
    <div class="titleSpace" [class.chargeListTitle]="addTitle">
        <button mat-icon-button (click)="slide()" class="backArrow">
            <i class="flaticon-back-arrow"></i>
        </button>
        <span>{{Title}}</span>
    </div>
</div>